export interface Module {
    id: string;
    name: string;
}

// Ids must stay in sync with the sidebar links in layout/sidebar/models/MenuItems.ts
// (moduleIdFromLink) — the sidebar gates each item's visibility against these same ids.
export const Modules: Module[] = [
    { id: 'dashboard', name: 'Dashboard' },
    { id: 'organizations', name: 'Organizations' },
    { id: 'properties', name: 'Properties' },
    { id: 'guests', name: 'Guests' },
    { id: 'reservations', name: 'Reservations' },
    { id: 'claims', name: 'Claims' },
    { id: 'policies', name: 'Insurance Policies' },
    { id: 'price-rates', name: 'Price Rates' },
    { id: 'verification-packages', name: 'Verification Packages' },
    { id: 'operations', name: 'Operations' },
    { id: 'underwriters', name: 'Underwriters' },
    { id: 'bad-guests', name: 'Bad Guests' },
    { id: 'referrals', name: 'Referrals' },
    { id: 'audit-trail', name: 'Audit Trail' }
];

// Modules gated by role permissions. Only these are listed in role details and checked by moduleAccessGuard
// and the sidebar; every other module stays open to all users. Add an id here to put a module under permissions.
export const PERMISSION_MODULE_IDS: readonly string[] = ['operations'];

export const requiresPermission = (moduleId: string): boolean => PERMISSION_MODULE_IDS.includes(moduleId);

export const PermissionModules: Module[] = Modules.filter(module => requiresPermission(module.id));

export const moduleIdFromLink =(link: string): string => link.replace(/^\//, '');
